// Imports
import React from 'react';
import styled from 'styled-components/macro';
import { useAppSelector } from '../../../../../../../shareables/foundation/front-end/redux/hooks';
import { GeneratedThemeProps } from '../../../../../../templates/template-style';
import SignInAnchor from '../../../../../sign-in-anchor';


// Styled component
const Wrapper = styled.div<{ theme: GeneratedThemeProps }>`
	border: 0.0625rem solid #ddd;
	border-radius: 0.1875rem;
	box-shadow: 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.05);
	padding: 0.9375rem 0.9375rem 0;
	margin-bottom: 1.25rem;
	padding-bottom: 0.9375rem;
	
	display: grid;
	grid-template-columns: 1fr auto;
	
	& > * {
		min-width: 0;
	}
	
	form {
		margin-bottom: 0 !important;
	}
`;

const SignIn = styled.div`
	line-height: 1.3125rem;
	
	a {
		color: inherit;
	}
`;

const Close = styled.span`
	display: block;
	width: 1.875rem;
	text-align: right;
	align-self: start;
	font-size: 1.3125rem;
	font-weight: bold;
	line-height: 1;
	text-shadow: 0 0.0625rem 0 #fff;
	cursor: pointer;
	
	&:hover,
	&:focus {
		color: hsl(0, 0%, 0%) !important;
	}
`;


// Define the accepted props
interface Props extends React.PropsWithChildren {
	closeOnClick: () => void;
	signInText?: string;
	showClose?: boolean;
}


// Function component
const Panel: React.FC<Props> = ({ closeOnClick, signInText, showClose, ...props }) => {
	// Use Redux functionality
	const signedIn = useAppSelector((state) => state.common.user.signedIn);
	
	
	// Return JSX
	return (
		<Wrapper>
			{signedIn ? (
				<React.Fragment>
					{props.children}
					{showClose && (
						<Close className='is-gray' onClick={closeOnClick}>
							&times;
						</Close>
					)}
				</React.Fragment>
			) : (
				<React.Fragment>
					<SignIn>
						<em>
							Please <SignInAnchor>sign in</SignInAnchor> before {signInText}.
						</em>
					</SignIn>
					
					<Close className='is-gray' onClick={closeOnClick}>
						&times;
					</Close>
				</React.Fragment>
			)}
		</Wrapper>
	);
};

export default Panel;
